// extracted by mini-css-extract-plugin
export default {"icon":"JobIcon-module_icon__32sbs"};